export function fillMissingYears(data, startDate = null, endDate = null) {
  if (data.length === 0 && !startDate && !endDate) {
    return [];
  }

  // Helper function to parse a year from the year string
  function parseYear(yearStr) {
    return parseInt(yearStr);
  }

  // Helper function to format the year back into a string
  function formatYear(year) {
    return year.toString();
  }

  // Helper function to add a number of years to a given year
  function addYears(year, numYears) {
    return year + numYears;
  }

  // Helper function to extract the year from a date string (YYYY-MM-DD)
  function getYearFromDate(dateStr) {
    return new Date(dateStr).getFullYear();
  }

  // Parse startDate and endDate (if provided)
  const startYear = startDate
    ? getYearFromDate(startDate)
    : parseYear(data[0][0]);
  const endYear = endDate ? getYearFromDate(endDate) : new Date().getFullYear();

  // Initialize a new array to hold the augmented data
  const augmentedData = [];

  // If data is empty and startDate/endDate is provided, fill the range
  if (data.length === 0 && startDate && endDate) {
    let currentYear = startYear;
    while (currentYear <= endYear) {
      augmentedData.push([
        formatYear(currentYear),
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
      ]);
      currentYear = addYears(currentYear, 1);
    }
    return augmentedData;
  }

  // Loop through the original data
  for (let i = 0; i < data.length; i++) {
    let currentYear = parseYear(data[i][0]);

    // Skip years before the start date
    if (currentYear < startYear) {
      continue;
    }

    // Add the current row to the augmented data
    augmentedData.push(data[i]);

    // If it's not the last row, check for missing years
    if (i < data.length - 1) {
      let nextYear = parseYear(data[i + 1][0]);

      // Get previous totalClicks and totalButtons
      let canceledClicks = data[i][10];
      let clicksToPay = data[i][11];
      let previousTotalClicks = data[i][12];
      let previousTotalButtons = data[i][13];

      // Fill in missing years between the current and next year
      while (currentYear < nextYear - 1) {
        currentYear = addYears(currentYear, 1);

        // Add a new row for the missing year
        augmentedData.push([
          formatYear(currentYear),
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          canceledClicks,
          clicksToPay,
          previousTotalClicks,
          previousTotalButtons,
        ]);
      }
    }
  }

  // Handle missing years up to the endDate or current year
  let lastYear = parseYear(augmentedData[augmentedData.length - 1][0]);
  let canceledClicks = augmentedData[augmentedData.length - 1][10];
  let clicksToPay = augmentedData[augmentedData.length - 1][11];
  let previousTotalClicks = augmentedData[augmentedData.length - 1][12];
  let previousTotalButtons = augmentedData[augmentedData.length - 1][13];

  while (lastYear < endYear) {
    lastYear = addYears(lastYear, 1);

    augmentedData.push([
      formatYear(lastYear),
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      canceledClicks,
      clicksToPay,
      previousTotalClicks,
      previousTotalButtons,
    ]);
  }

  return augmentedData;
}
